var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Outlet } from 'react-router-dom';
import { ConstructorHeader } from '../components';
export var ConstructorLayout = function () {
    // useLayoutEffect(() => {
    // 	navigate(
    // 		`${APP_ROUTES.designing.route}/${DESIGNING_ROUTES.constructor.route}/${CONSTRUCTOR_ROUTES.aboutBuilding.route}`,
    // 	);
    // }, []);
    return (_jsxs("div", __assign({ className: "flex w-full flex-col gap-[30px] pb-[29px]" }, { children: [_jsx(ConstructorHeader, {}), _jsx(Outlet, {})] })));
};
